// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hd-0";